var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4a1 1 0 1 0 0-2v2Zm10 8a1 1 0 1 0-2 0h2ZM12 8.5a1 1 0 1 0 0-2v2Zm5.5 3.5a1 1 0 1 0-2 0h2Zm-6.207-.707a1 1 0 1 0 1.414 1.414l-1.414-1.414Zm4.564-1.74a1 1 0 1 0-1.414-1.413l1.414 1.414Zm-.707-3.84-.709-.705a1 1 0 0 0-.291.705h1Zm0 3.137h-1a1 1 0 0 0 1 1v-1Zm3.162 0v1a1 1 0 0 0 .71-.295l-.71-.705ZM21 6.15l.709.706A1 1 0 0 0 21 5.15v1Zm-3.148 0h-1a1 1 0 0 0 1 1v-1Zm0-3.15h1a1 1 0 0 0-1.709-.706l.709.706ZM12 2C6.477 2 2 6.477 2 12h2a8 8 0 0 1 8-8V2ZM2 12c0 5.523 4.477 10 10 10v-2a8 8 0 0 1-8-8H2Zm10 10c5.523 0 10-4.477 10-10h-2a8 8 0 0 1-8 8v2Zm0-15.5A5.5 5.5 0 0 0 6.5 12h2A3.5 3.5 0 0 1 12 8.5v-2ZM6.5 12a5.5 5.5 0 0 0 5.5 5.5v-2A3.5 3.5 0 0 1 8.5 12h-2Zm5.5 5.5a5.5 5.5 0 0 0 5.5-5.5h-2a3.5 3.5 0 0 1-3.5 3.5v2Zm.707-4.793 3.15-3.153-1.414-1.414-3.15 3.153 1.414 1.414Zm1.443-6.994V8.85h2V5.713h-2Zm1 4.137h3.162v-2H15.15v2Zm3.871-.295 2.688-2.7-1.418-1.41-2.687 2.7 1.417 1.41ZM21 5.15h-3.148v2H21v-2Zm-2.148 1V3h-2v3.15h2Zm-1.709-3.856-2.702 2.714 1.418 1.41 2.701-2.712-1.417-1.412Z",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.2158d2d7a00611ecc27f97400d10984d.svg";
export { ForwardRef as ReactComponent };